export default function(data) {
var __t, __p = '';
__p += '<div class="collection clearfix medium-flush-1 small-flush-1"></div>\n<div class="pagination ' +
((__t = ( this.mainModel )) == null ? '' : __t) +
'">\n</div>\n';
return __p
}